module.exports = __webpack_public_path__ + "img/07.972663cd.png";